import { apiCall } from './gqlClient';

const GETFILES_QUERY = `
  query getFiles($sectionId: String!) {
    getFiles(sectionId: $sectionId)
    {
      id
			productId
			sectionId
			title
			description
			type
			free
			intro
			name
			updated
			transcoded
			orderIndex
			isPublic
			tempProductId
			tempFileId
			thumbnailUrl
			copyId
			seen
			fileCreated
			dateCreated
			videoUrl
      ...fragments
    }
  }`;

export const getFilesApiCall = async ({sectionId}, fragments = null) => apiCall({ query: GETFILES_QUERY, variables: {sectionId}, fragments });

const GETALLMEDIAFILES_QUERY = `
  query getAllMediaFiles {
    getAllMediaFiles
    {
      id
			productId
			sectionId
			title
			description
			type
			free
			intro
			name
			updated
			transcoded
			orderIndex
			isPublic
			tempProductId
			tempFileId
			thumbnailUrl
			copyId
			seen
			fileCreated
			dateCreated
			videoUrl
      ...fragments
    }
  }`;

export const getAllMediaFilesApiCall = async (fragments = null) => apiCall({ query: GETALLMEDIAFILES_QUERY, variables: {}, fragments });

const SAVEFILE_QUERY = `
  query saveFile($request: FileInput!) {
    saveFile(request: $request)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const saveFileApiCall = async ({request}, fragments = null) => apiCall({ query: SAVEFILE_QUERY, variables: {request}, fragments });

const GETFILE_QUERY = `
  query getFile($id: String!) {
    getFile(id: $id)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const getFileApiCall = async ({id}, fragments = null) => apiCall({ query: GETFILE_QUERY, variables: {id}, fragments });

const GETFILEFROMCUSTOMERFLOW_QUERY = `
  query getFileFromCustomerFlow($fileId: String!, $customerFlowId: String!) {
    getFileFromCustomerFlow(fileId: $fileId, customerFlowId: $customerFlowId)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const getFileFromCustomerFlowApiCall = async ({fileId, customerFlowId}, fragments = null) => apiCall({ query: GETFILEFROMCUSTOMERFLOW_QUERY, variables: {fileId, customerFlowId}, fragments });

const GETFILEONBOARDING_QUERY = `
  query getFileOnboarding($id: String!) {
    getFileOnboarding(id: $id)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const getFileOnboardingApiCall = async ({id}, fragments = null) => apiCall({ query: GETFILEONBOARDING_QUERY, variables: {id}, fragments });

const CHECKFILECONNECTIONS_QUERY = `
  query checkFileConnections($id: String!, $name: String) {
    checkFileConnections(id: $id, name: $name)
  }`;

export const checkFileConnectionsApiCall = async ({id, name}, ) => apiCall({ query: CHECKFILECONNECTIONS_QUERY, variables: {id, name}});

const GETCUSTOMERFILE_QUERY = `
  query getCustomerFile($id: String!, $providerId: Int!) {
    getCustomerFile(id: $id, providerId: $providerId)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const getCustomerFileApiCall = async ({id, providerId}, fragments = null) => apiCall({ query: GETCUSTOMERFILE_QUERY, variables: {id, providerId}, fragments });

const GETCUSTOMERPUBLICFILE_QUERY = `
  query getCustomerPublicFile($id: String!, $providerId: Int!) {
    getCustomerPublicFile(id: $id, providerId: $providerId)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const getCustomerPublicFileApiCall = async ({id, providerId}, fragments = null) => apiCall({ query: GETCUSTOMERPUBLICFILE_QUERY, variables: {id, providerId}, fragments });

const GETSEENFILESREPORT_QUERY = `
  query getSeenFilesReport($productId: String!, $users: [Int]!) {
    getSeenFilesReport(productId: $productId, users: $users)
    {
      id
			name
			email
			sectionName
			watched
			total
			percentage
      ...fragments
    }
  }`;

export const getSeenFilesReportApiCall = async ({productId, users}, fragments = null) => apiCall({ query: GETSEENFILESREPORT_QUERY, variables: {productId, users}, fragments });

const ADDFILETOSECTION_QUERY = `
  mutation addFileToSection($id: String!, $sectionId: String!, $sectionIndex: Int!) {
    addFileToSection(id: $id, sectionId: $sectionId, sectionIndex: $sectionIndex)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const addFileToSectionApiCall = async ({id, sectionId, sectionIndex}, fragments = null) => apiCall({ query: ADDFILETOSECTION_QUERY, variables: {id, sectionId, sectionIndex}, fragments });

const DELETEFILE_QUERY = `
  mutation deleteFile($id: String!, $sectionIndex: Int) {
    deleteFile(id: $id, sectionIndex: $sectionIndex)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const deleteFileApiCall = async ({id, sectionIndex}, fragments = null) => apiCall({ query: DELETEFILE_QUERY, variables: {id, sectionIndex}, fragments });

const REORDERFILES_QUERY = `
  mutation reorderFiles($sectionId: String!, $oldPosition: Int!, $newPosition: Int!) {
    reorderFiles(sectionId: $sectionId, oldPosition: $oldPosition, newPosition: $newPosition)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const reorderFilesApiCall = async ({sectionId, oldPosition, newPosition}, fragments = null) => apiCall({ query: REORDERFILES_QUERY, variables: {sectionId, oldPosition, newPosition}, fragments });

const DELETEALLFILESINSECTION_QUERY = `
  mutation deleteAllFilesInSection($id: String!, $sectionIndex: Int!) {
    deleteAllFilesInSection(id: $id, sectionIndex: $sectionIndex)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const deleteAllFilesInSectionApiCall = async ({id, sectionIndex}, fragments = null) => apiCall({ query: DELETEALLFILESINSECTION_QUERY, variables: {id, sectionIndex}, fragments });

const MARKFILESEENUNSEEN_QUERY = `
  mutation markFileSeenUnseen($fileId: String!, $seen: Boolean!) {
    markFileSeenUnseen(fileId: $fileId, seen: $seen)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const markFileSeenUnseenApiCall = async ({fileId, seen}, fragments = null) => apiCall({ query: MARKFILESEENUNSEEN_QUERY, variables: {fileId, seen}, fragments });
